import React from 'react';
import Sidebar from './Sidebar';
import { SidebarProvider, useSidebar } from '../../contexts/SidebarContext';
import { useLanguage } from '../../contexts/LanguageContext';

interface AdminLayoutProps {
  children: React.ReactNode;
}

const AdminLayoutContent: React.FC<AdminLayoutProps> = ({ children }) => {
  const { isCollapsed } = useSidebar();
  const { setLanguage, currentLanguage } = useLanguage();

  // Enforce French language for Admin Dashboard
  React.useEffect(() => {
    if (currentLanguage !== 'fr') {
      setLanguage('fr');
    }
  }, [currentLanguage, setLanguage]);

  return (
    <div className="h-screen bg-gray-50 dark:bg-dark-navy flex overflow-hidden relative">
      {/* Light mode background pattern */}
      <div className="absolute inset-0 pointer-events-none dark:hidden" style={{
        backgroundImage: `radial-gradient(circle, #e5e7eb 1px, transparent 1px)`,
        backgroundSize: '20px 20px'
      }}></div>
      {/* Dark mode background pattern */}
      <div className="absolute inset-0 pointer-events-none hidden dark:block" style={{
        backgroundImage: `radial-gradient(circle, #2D3748 1px, transparent 1px)`,
        backgroundSize: '20px 20px'
      }}></div>
      <Sidebar />
      <div className={`flex-1 ${isCollapsed ? 'ml-20' : 'ml-80'} flex flex-col overflow-hidden relative z-0 transition-all duration-300 ease-in-out`}>
        <div className="flex-1 overflow-y-auto p-6">
          <div className="max-w-7xl mx-auto">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  return (
    <SidebarProvider>
      <AdminLayoutContent>
        {children}
      </AdminLayoutContent>
    </SidebarProvider>
  );
};

export default AdminLayout;
